<template>
	<div class="numberTwoBox">
		<div v-for="(item,index) in hospitalCountList" :key="item.name" :class="index==hospitalCountList.length-1||index==hospitalCountList.length-2?'numberFrame':'numberFrame marb25'">
				<i :class="`visSubpageNumber ${item.icon}`"></i>
				<div class="inlin fz12">
					<numberGrow class="fz24" v-if="destroy.flag" :value="Number(item.number)"></numberGrow>
					<span> {{item.unit}}</span><br />
					<div>
						<span style="color:'#ABABAB'">{{item.name}}</span>
						<el-tooltip class="item" effect="dark" v-if="item.computingMethod" :content="item.computingMethod" placement="bottom">
							<span><i class="el-icon-question" style="color: #FF8F28;vertical-align: bottom;"></i></span>
						</el-tooltip>
					</div>
				</div>
		</div>
	</div>
</template>
<script>
	import numberGrow from '../../components/tool/numberGrow'
	// import { mapState, mapActions, mapMutations} from 'vuex'
	export default {
		props:['hospitalCountList'],
		components: {
			numberGrow,
		},
		data() {
			return {}
		},
		computed: {
			...Vuex.mapState('supervisor', ['destroy']),
			...Vuex.mapState('visualization', ['reportCountList'])
		},
		mounted(){
		},
		methods: {}
	}
</script>

<style>
</style>
